import { render, staticRenderFns } from "./PageShareAccessDenied.vue?vue&type=template&id=67f17c2e&scoped=true&"
import script from "./PageShareAccessDenied.vue?vue&type=script&lang=js&"
export * from "./PageShareAccessDenied.vue?vue&type=script&lang=js&"
import style0 from "./PageShareAccessDenied.vue?vue&type=style&index=0&id=67f17c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f17c2e",
  null
  
)

export default component.exports